import React from 'react';
import { Row, Skeleton, Divider } from 'antd';
import { useTranslation } from 'react-i18next';

const PaymentSkeleton = () => {
  const { t } = useTranslation();

  return (
    <Row
      type="flex"
      className="campaingInfoCard customPanelStyleDisplays"
      style={{ position: 'relative' }}
    >
      <div>
        <div className="ant-collapse-header" style={{ marginTop: '10px' }}>
          {t('Campaign payment')}
        </div>
        <div className="ant-collapse-sub-header" style={{ paddingLeft: '10px' }}>
          {t('Payment method')}
        </div>
      </div>
      <Skeleton paragraph={{ rows: 5 }} />
      <Divider style={{ marginTop: '29px' }} className="divider-payment" />
      <div className="ant-collapse-sub-header" style={{ marginTop: '30px' }}>
        {t('Fill in the following information')}
      </div>
      <Skeleton paragraph={{ rows: 5 }} />
    </Row>
  );
};

export default PaymentSkeleton;
